<template>
  <div class="space-y-24">
    <BenefitTable
      :firstColumnTitle="i18n(translations.included)"
      :secondColumnTitle="i18n(translations.notIncluded)"
    >
      <template #rows>
        <BenefitRow
          :firstColumn="i18n(translations.crackedScreen)"
          :secondColumn="i18n(translations.batteryHealthDegradation)"
        />
        <BenefitRow
          :firstColumn="i18n(translations.crackedRearGlassOrDamagedBody)"
          :secondColumn="i18n(translations.theftOrLoss)"
        />
        <BenefitRow :firstColumn="i18n(translations.waterDamage)" />
        <BenefitRow
          :firstColumn="i18n(translations.stuckPowerOrVolumeButtons)"
        />
        <BenefitRow :firstColumn="i18n(translations.physicalFaults)" />
        <BenefitRow :firstColumn="i18n(translations.softwareFaults)" />
      </template>
    </BenefitTable>

    <div class="caption gap-8 flex flex-col">
      <p>
        {{ i18n(translations.nonExhaustiveNote) }}
      </p>
      <p>
        {{ i18n(translations.batteryHealthDegradationNote) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import BenefitRow from '../BenefitRow/BenefitRow.vue'
import BenefitTable from '../BenefitTable/BenefitTable.vue'

import translations from './Benefits.translations'

const i18n = useI18n()
</script>
